module.exports = __webpack_public_path__ + "static/media/gallery9.24b9c77a.png";